import React from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import * as actions from "../../actions";
import { Form, Input, Button, Row, Col, Icon, Spin } from "antd";
import { Country, State, City } from "country-state-city";
import countryList from "react-select-country-list";
import { v4 as uuidv4 } from "uuid";
import Select from "react-select";

export const INSURANCE_PROFIT_PERCENT = 0.1;

const labelStyle = {
  fontSize: "16px",
  width: "100%",
  textAlign: "left",
  whiteSpace: "normal",
  display: "inline-flex",
};

const customStyles = {
  control: (baseStyles, state) => ({
    ...baseStyles,
    padding: 0,
    margin: 0,
  }),
  option: (provided) => ({
    ...provided,
    padding: "0 10px", // Remove padding
    margin: 0, // Remove margin
  }),
  menu: (provided) => ({
    ...provided,
    margin: 0, // Remove margin
    padding: 0, // Remove padding
  }),
  menuList: (provided) => ({
    ...provided,
    padding: 0, // Remove padding
  }),
  singleValue: (provided) => ({
    ...provided,
    margin: 0, // Remove margin
    padding: 0, // Remove padding
  }),
  placeholder: (provided) => ({
    ...provided,
    margin: 0, // Remove margin
    padding: 0, // Remove padding
  }),
  input: (provided) => ({
    ...provided,
    margin: 0,
    padding: 0,
  }),
};

class CargoInsurance extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      loadingPolicy: false,
      CountryISOEnum: {},
      authToken: null,
      category: {},
      insurance: [],
      shouldValidate: false
    };
  }

  findISOCodeByCountryName = (countryName) => {
    //console.log("countryName: ", countryName);
    if (countryName === "USA") {
      countryName = "United States";
    }
    const list = countryList().getData();
    //console.log("list: ", list);
    const country = list.find((c) => c.label === countryName);
    return country ? country.value : null;
  };

  // Function to remove accents/diacritics from a string
  removeAccents = (str) => {
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  };

  // Function to normalize city names (convert to lowercase and remove accents)
  normalizeCityName = (cityName) => {
    return this.removeAccents(cityName).toLowerCase();
  };

  findStateCodeByCityAndCountryName = (cityName, countryName) => {
    let cityFound = null;
    if (countryName === "Canada") {
      // First, find the country code based on the country name
      const country = Country.getAllCountries().find(
        (c) => c.name === countryName
      );
      if (!country) return null; // Country not found
      // console.log("country: ", country, country.isoCode);
      // Then, find all states within this country
      const states = State.getStatesOfCountry(country.isoCode);
      // console.log("states: ", states);
      // Now, find the city by name within the found states

      for (let state of states) {
        const cities = City.getCitiesOfState(country.isoCode, state.isoCode);
        const city = cities.find(
          (c) =>
            this.normalizeCityName(c.name) === this.normalizeCityName(cityName)
        );
        // console.log("cities: ", cities, "city: ", city);
        if (city) {
          cityFound = city;
          break;
        }
      }
    }
    // Return the state code of the found city, or null if not found
    return cityFound ? cityFound.stateCode : null;
  };

  handleSubmit = async (values) => {
    const {
      queryParams,
      final_search_form,
      commodityList,
      insuranceToken,
      user,
      booking_customer_form,
    } = this.props;

    // Check if userId exists and is not null/undefined
    const isUserPresent = user.webuser?.userid != null;

    const customer = {
      address: booking_customer_form?.address,
      companyCode: booking_customer_form?.company_name,
      companyName: booking_customer_form?.company_name,
      countryCode: this.findISOCodeByCountryName(
        booking_customer_form?.country
      ),
      country: booking_customer_form?.country,
    };
    //console.log("customer: ",customer)
    const commodities = values?.commodityArr || [];

    let commodityObj = {
      currency_code: "USD",
      container_mode:
        final_search_form?.type === "api-fcl"
          ? "FCL"
          : final_search_form?.type === "api-lcl"
          ? "LCL"
          : null,
      origin_port_code: queryParams?.from?.portCode,
      // destination_port_code:
      //   final_search_form?.selected_card_json?.port_of_discharge?.scac_code,
      destination_port_code: queryParams?.to?.portCode,
      etd: final_search_form?.selected_card_json?.etd_origin,
      primary_mode_of_transport:
        final_search_form?.selected_card_json?.mode.toLowerCase(),
    };

    if (commodities && commodities.length > 0) {
      this.setState({ loading: true });
      const insuranceResults = await this.processCommodities(
        commodities,
        commodityObj,
        insuranceToken,
        customer,
        isUserPresent
      );
      this.setState({ loading: false });
      if (insuranceResults && insuranceResults.length > 0) {
        this.setState({ insurance: insuranceResults });
      }
      //console.log("Insurance Results: ", insuranceResults);
      this.props.onInsuranceAmountChange(insuranceResults);
    } else {
      console.log("Error in fetching form values");
      this.setState({ loading: false });
    }
  };

  processCommodities = async (
    commodities,
    commodityBase,
    insuranceToken,
    customer,
    isUserPresent
  ) => {
    return Promise.all(
      commodities.map(async (commodity) => {
        const commodityObj = this.createCommodityObject(
          commodity,
          commodityBase
        );

        try {
          const result = await this.props.getInsuranceQuoteFromAPI(
            isUserPresent,
            insuranceToken,
            commodityObj,
            customer
          );
          // console.log("Result: ", result);
          return this.handleInsuranceResult(result, commodityObj);
        } catch (error) {
          console.log("Error in getting cargo insurance: ", error);
          return null;
        }
      })
    );
  };
  createCommodityObject = (commodity, commodityBase) => {
    const selectedCategory = commodity?.category
      ? this.props.commodityList.find(
          (item) => item.id === commodity.category.value
        )
      : {};
    return {
      ...commodityBase,
      commodity_description: commodity?.description,
      commodity_category_type: selectedCategory?.commodity_type,
      commodity_category_type_id: selectedCategory?.id,
      commodity_value: commodity?.commodityValue,
      profit_percent: INSURANCE_PROFIT_PERCENT,
      shipment_id: uuidv4(),
    };
  };

  handleInsuranceResult = (result, commodityObj) => {
    if (result?.[0] && result?.[1]) {
      // console.log("Quote Created: ", result[1]);
      if (result[1]?.result_code !== "quote_created") {
        this.props.updateErrorAndLoading(
          `An instant rate was not available for ${commodityObj.commodity_category_type}. Insurance has been requested, and we will provide a quote shortly.`,
          false
        );
      }
      if (result[1]?.premium_amount) {
        result[1].premium_amount = Number(
          (
            result[1]?.premium_amount +
            result[1]?.premium_amount * INSURANCE_PROFIT_PERCENT
          ).toFixed(2)
        );
      }
      return { ...commodityObj, quote: result[1] };
    } else {
      this.props.updateErrorAndLoading(
        "Unable to retrieve the insurance quote at this time. Please try again shortly.",
        false
      );
      return null;
    }
  };

  // Method to handle the insurance calculation button click
  calculateInsurance = () => {
    const { form } = this.props;
    const values = form.getFieldsValue(["commodityArr"]);
  
    // Check if user has started filling any field in commodityArr
    const shouldValidate = values.commodityArr.some(
      (commodity) =>
        commodity?.category === undefined || commodity?.category === "" ||
        commodity?.description === undefined || commodity?.description === "" ||
        commodity?.commodityValue === undefined || commodity?.commodityValue === ""
    );
  
    if (shouldValidate) {
      // **Enable required validation**
      this.setState({ shouldValidate: true }, () => {
        let validationFields = [];
        values.commodityArr.forEach((commodity, index) => {
          validationFields.push(
            `commodityArr[${index}].category`,
            `commodityArr[${index}].description`,
            `commodityArr[${index}].commodityValue`
          );
        });
  
        // **Now enforce validation**
        form.validateFields(validationFields, { force: true }, (errors, values) => {
          if (!errors) {
            // console.log("Validated successfully:", values);
            this.handleSubmit(values);
          } else {
            console.error("Validation errors found: ", errors);
          }
        });
      });
    } else {
      // console.log("Skipping validation as no fields were entered.");
      this.handleSubmit(values);
    }
  };

  processInsuranceQuotes = async (insurance, insuranceToken, isUserPresent) => {
    return Promise.all(
      insurance.map(async (insuranceElement) => {
        // console.log("insurance: ", insuranceElement);
        const quoteID = insuranceElement?.quote?.quote_id;
        const resultCode = insuranceElement?.quote?.result_code;
        if (resultCode === "quote_created" && quoteID) {
          //console.log("quoteID ", quoteID,"\ninsuranceToken: ",insuranceToken,"\nisUSerresent: ",isUserPresent);
          try {
            const result = await this.props.getInsurancePolicyFromAPI(
              isUserPresent,
              insuranceToken,
              quoteID
            );
            // console.log("Result: ", result);
            // Assuming result contains a policy_id field
            if (result[0] && result?.[1] && result[1]?.policy_id) {
              // Add policy_id to the insuranceElement
              insuranceElement.policy_id = result[1].policy_id;
              // console.log("Updated insurance element with policy_id: ", insuranceElement);
              // this.props.updateErrorAndLoading(`Policy has been cretaed for ${insuranceElement?.commodity_category_type}.`, false);
            }
          } catch (error) {
            console.log("Error in getting cargo insurance: ", error);
            return null;
          }
        } else {
          console.log(
            `Insurance Quote has not been generated for quoteId: ${quoteID}`
          );
        }
        return insuranceElement; // Return updated insurance element
      })
    );
  };
  createPolicy = async () => {
    const { insuranceToken, user } = this.props;
    const isUserPresent = user.webuser?.userid != null;
    console.log("createPolicy is executing.... ", this.state.insurance);
    if (this.state?.insurance && this.state.insurance.length > 0) {
      this.setState({ loadingPolicy: true });
      const updatedInsurance = await this.processInsuranceQuotes(
        this.state.insurance,
        insuranceToken,
        isUserPresent
      );
      // console.log("Updated insurance with policy_id: ", updatedInsurance);

      // Extract descriptions of elements that contain policy_id
      const descriptions = updatedInsurance
        .filter((item) => item.policy_id != null) // Check if policy_id is not null or undefined
        .map((item) => item.commodity_description) // Extract the description
        .join(", "); // Join descriptions into a comma-separated string

      if (descriptions) {
        this.props.updateErrorAndLoading(
          `Policy has been created for ${descriptions}.`,
          false
        );
      } else {
        this.props.updateErrorAndLoading(
          `Policy can not be created as quote has been requested.`,
          false
        );
      }
      // If you need to update the state with the updated insurance data
      this.setState({ insurance: updatedInsurance });
      this.props.onInsuranceAmountChange(updatedInsurance);
      this.setState({ loadingPolicy: false });
    }
  };

  render() {
    const {
      form,
      commodityList,
      commodityArr,
      onCommodityChange,
      onAddCommodity,
      onDeleteCommodity,
      user
    } = this.props;
    const { getFieldDecorator } = form;
    // Convert commodityList to the format required by react-select
    const options =
      commodityList && commodityList.length > 0
        ? commodityList.map((item) => ({
            value: item.id,
            label: item.commodity_type,
          }))
        : [];
    const isUserPresent = user.webuser?.userid != null;

    return (
      <Form>
        {commodityArr?.map((commodity, index) => (
          <Form.Item key={index}>
            <div key={index}>
              <Row>
                <Col xs={24} sm={24} md={24}>
                  <Form.Item
                    label={<span style={labelStyle}>Commodity Category</span>}
                    style={{ marginBottom: "0" }}
                  >
                    {getFieldDecorator(`commodityArr[${index}].category`, {
                      initialValue: commodity.category
                        ? {
                            value: commodity.category,
                            label: commodity.category,
                          }
                        : undefined,
                      rules: [
                        {
                          required: this.state.shouldValidate,
                          message: "Required",
                        },
                      ],
                    })(
                      <Select
                        name="category"
                        options={options}
                        placeholder="Select a commodity type"
                        isSearchable
                        onChange={(selectedOption) => {
                          onCommodityChange(
                            index,
                            "category",
                            selectedOption.value
                          );
                        }}
                        styles={customStyles}
                      />
                    )}
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={[{ xs: 8, sm: 16, md: 24, lg: 32 }, 16]}>
                <Col xs={24} sm={24} md={12}>
                  <Form.Item
                    label={
                      <span style={labelStyle}>Commodity Description</span>
                    }
                    style={{ marginBottom: "0" }}
                  >
                    {getFieldDecorator(`commodityArr[${index}].description`, {
                      initialValue: commodity?.description || "",
                      rules: [
                        {
                          required: this.state.shouldValidate,
                          message: "required",
                        },
                      ],
                    })(
                      <Input
                        name="description"
                        size="large"
                        autoComplete="off"
                        placeholder="Describe the commodity"
                        onChange={(e) => {
                          onCommodityChange(
                            index,
                            "description",
                            e.target.value
                          );
                        }}
                      />
                    )}
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={12}>
                  <Form.Item
                    label={<span style={labelStyle}>Commodity Value</span>}
                    style={{ marginBottom: "0" }}
                  >
                    {getFieldDecorator(
                      `commodityArr[${index}].commodityValue`,
                      {
                        initialValue: commodity?.commodityValue || "",
                        rules: [
                          {
                            required: this.state.shouldValidate,
                            message: "required",
                          },
                          {
                            pattern: /^\d+(\.\d+)?$/, // Regular expression to accept integers or decimal numbers
                            message: "Please enter a valid price",
                          },
                        ],
                      }
                    )(
                      <Input
                        name="commodityValue"
                        size="large"
                        autoComplete="off"
                        placeholder="Enter amount"
                        addonBefore={
                          <span className="input-prefix">$ USD</span>
                        }
                        onChange={(e) => {
                          onCommodityChange(
                            index,
                            "commodityValue",
                            e.target.value
                          );
                        }}
                      />
                    )}
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                {/* Other input fields */}
                <Col xs={24} sm={24} md={6}>
                  <div style={{ display: "flex", paddingTop: "1rem" }}>
                    <Button
                      type="primary"
                      onClick={onAddCommodity}
                      style={{
                        width: "100%",
                        marginRight: commodityArr.length > 1 ? "10px" : "0px",
                      }}
                      ghost
                    >
                      <Icon type="plus" /> Add
                    </Button>
                    {commodityArr.length > 1 && (
                      <Button
                        type="danger"
                        //onClick={() => onDeleteCommodity(index)}
                        onClick={() => {
                          onDeleteCommodity(index);
                          const { insurance } = this.state;
                          let insuranceFiltered = insurance.filter(
                            (_, idx) => idx !== index
                          );
                          this.setState({
                            insurance: insuranceFiltered,
                          });
                          this.props.onInsuranceAmountChange(insuranceFiltered);
                        }}
                        style={{ width: "100%" }}
                        ghost
                      >
                        <Icon type="minus" /> Delete
                      </Button>
                    )}
                  </div>
                </Col>
              </Row>
            </div>
          </Form.Item>
        ))}
        <Row gutter={[{ xs: 8, sm: 16, md: 24, lg: 32 }, 16]}>
          <Col xs={24} sm={12} md={12} lg={12}>
            <Button
              onClick={this.calculateInsurance}
              disabled={this.state.loading}
              style={{
                backgroundColor: "#ECECEC",
                color: "#000",
                width: "100%",
              }}
            >
              Calculate Insurance{" "}
              {this.state.loading && (
                <Spin
                  style={{
                    marginLeft: "10px",
                    marginRight: "10px",
                  }}
                  indicator={
                    <Icon type="loading" style={{ fontSize: 24 }} spin />
                  }
                />
              )}
            </Button>
          </Col>
          {isUserPresent &&
          <Col xs={24} sm={12} md={12} lg={12}>
            <Button
              onClick={this.createPolicy}
              disabled={this.state.loadingPolicy}
              style={{
                backgroundColor: "#ECECEC",
                width: "100%",
                color: "#000",
              }}
            >
              Create Policy
              {this.state.loadingPolicy && (
                <Spin
                  style={{
                    marginLeft: "10px",
                    marginRight: "10px",
                  }}
                  indicator={
                    <Icon type="loading" style={{ fontSize: 24 }} spin />
                  }
                />
              )}
            </Button>
          </Col>
        }
        </Row>
        {isUserPresent &&
        <div>
          <p>
            <span style={{ color: "red" }}>* </span>An insurance policy must be
            created in order to obtain coverage.
          </p>
        </div>
        }
      </Form>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    jwt_token: state.route.JWT_TOKEN.JWT_TOKEN,
    user: state.route.USER_DETAILS,
    queryParams: state.route.queryParams,
    final_search_form: state.route.final_search_form,
    commodityList: state.route.commodityList,
    insuranceToken: state.route.insuranceToken,
    booking_customer_form: state.route.booking_customer_form,
  };
};

export default withRouter(connect(mapStateToProps, actions)(CargoInsurance));
